import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/data-empty.png'


const _hoisted_1 = { class: "flex flex-col items-center py-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "empty"
  })
], -1)
const _hoisted_3 = { class: "text-xl font-bold" }

import {
  withDefaults,
  toRefs
} from 'vue'

type TEmptyStateProps = {
  text: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'State',
  props: {
    text: { default: 'Tidak ada data ditemukan.' }
  },
  setup(__props: any) {

const props = __props as { text: string }



const {
  text
} = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(text)), 1)
  ]))
}
}

})